<div class="compras-internas">
  <div class="d-flex flex-wrap justify-content-between align-items-start mb-3">
    <div class="d-flex flex-wrap">
      <button class="btn mr-2 mb-2" [ngClass]="area === 'realizados' ? 'btn-blue' : 'btn-light'"
              (click)="selecioneArea('realizados')">
        <i class="fe-list mr-1"></i>Pedidos realizados
      </button>
      <button class="btn mb-2" [ngClass]="area === 'novo' ? 'btn-blue' : 'btn-light'"
              (click)="selecioneArea('novo')">
        <i class="fe-plus mr-1"></i>Novo pedido
      </button>
    </div>
    <a class="btn btn-outline-info mb-2" href="/ajuda/compras-internas/"
       target="_blank" rel="noopener" title="Abrir guia de pedidos internos">
      <i class="far fa-question-circle mr-1"></i>Ajuda
    </a>
  </div>

  <div class="alert alert-danger" *ngIf="mensagemErro">{{mensagemErro}}</div>
  <div class="alert alert-success" *ngIf="mensagemSucesso">{{mensagemSucesso}}</div>

  <ng-container *ngIf="area === 'novo'">
    <div class="alert alert-warning" *ngIf="!carregandoCatalogo && !catalogo.fornecimento">
      Esta filial ainda não possui uma fábrica fornecedora ativa.
    </div>
    <div class="fornecedor-compra-interna d-flex flex-wrap justify-content-between align-items-center"
         *ngIf="catalogo.fornecimento">
      <div class="d-flex align-items-center">
        <span class="fornecedor-compra-interna__icone"><i class="fas fa-store-alt"></i></span>
        <div>
          <small>Fornecedor</small>
          <strong>{{catalogo.fornecimento.fabrica.nome}}</strong>
          <span *ngIf="catalogo.fornecimento.fabrica.cnpj"> — CNPJ {{catalogo.fornecimento.fabrica.cnpj}}</span>
        </div>
      </div>
      <button type="button" class="btn btn-sm btn-outline-info ml-2"
              (click)="abraProdutosFabrica()" [disabled]="carregandoProdutosFabrica">
        <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoProdutosFabrica"></span>
        <i class="fe-list mr-1" *ngIf="!carregandoProdutosFabrica"></i>Ver produtos
      </button>
    </div>

    <div class="aviso-configuracao-compra d-flex flex-wrap justify-content-between align-items-center"
         *ngIf="!carregandoCatalogo && catalogo.fornecimento && itensNaoConfigurados > 0">
      <div>
        <i class="fas fa-exclamation-triangle mr-1"></i>
        Você tem <strong>{{itensNaoConfigurados}}
        {{itensNaoConfigurados === 1 ? 'produto não configurado' : 'produtos não configurados'}}</strong>
        para compra interna. Configure antes de fazer o pedido.
      </div>
      <a class="btn btn-sm btn-outline-warning ml-2"
         href="/ajuda/compras-internas/#de-para" target="_blank" rel="noopener">
        <i class="far fa-question-circle mr-1"></i>Ver como configurar
      </a>
    </div>

    <div class="barra-novo-pedido" *ngIf="catalogo.fornecimento">
      <div class="busca-novo-pedido">
        <i class="fas fa-search"></i>
        <input kendoTextBox type="search" class="form-control"
               [(ngModel)]="filtroNovoPedido" placeholder="Buscar por insumo ou produto..." />
      </div>
      <span class="contador-novo-pedido">
        <i class="fas fa-check-circle mr-1"></i>
        {{quantidadeItensSelecionados()}}
        {{quantidadeItensSelecionados() === 1 ? 'item no pedido' : 'itens no pedido'}}
      </span>
    </div>

    <kendo-grid [data]="itensDoNovoPedido()" [loading]="carregandoCatalogo"
                [class]="'gridProdutos grid-novo-pedido'">
      <kendo-grid-messages noRecords="Nenhum insumo configurado para compra interna."></kendo-grid-messages>
      <kendo-grid-column title="Insumo" [width]="190">
        <ng-template kendoGridCellTemplate let-item>
          <strong>{{item.insumo.nome}}</strong>
          <small class="d-block text-muted">{{item.insumo.codigo || 'Sem código'}}</small>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Estoque" [width]="125">
        <ng-template kendoGridCellTemplate let-item>
          <strong [ngClass]="{'text-danger': estoqueAbaixoMinimo(item)}">
            {{item.insumo.estoqueAtual | number:'1.0-6'}} {{item.insumo.unidadeMedida.sigla}}
          </strong>
          <small class="d-block text-muted">Mínimo: {{item.insumo.estoqueMinimo | number:'1.0-6'}}</small>
          <span class="badge badge-danger" *ngIf="estoqueAbaixoMinimo(item)">Abaixo do mínimo</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Forma de compra" [width]="215">
        <ng-template kendoGridCellTemplate let-item>
          <kendo-combobox class="w-100" [data]="item.apresentacoes" textField="descricao"
                          [(ngModel)]="item.apresentacaoSelecionada" [allowCustom]="false"
                          (ngModelChange)="alterouApresentacao(item)" [disabled]="!item.apresentacoes.length">
          </kendo-combobox>
          <small *ngIf="item.apresentacaoSelecionada" class="d-block text-muted">
            1 {{item.apresentacaoSelecionada.descricao}} =
            {{item.apresentacaoSelecionada.fatorConversao | number:'1.0-6'}}
            {{item.insumo.unidadeMedida.sigla}}
          </small>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Produto da fábrica" [width]="190">
        <ng-template kendoGridCellTemplate let-item>
          <strong>{{item.apresentacaoSelecionada.vinculo.produto.nome}}</strong>
          <small class="d-block text-muted">
            {{item.apresentacaoSelecionada.vinculo.produto.preco | currency:'BRL'}}
          </small>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Quantidade" [width]="105">
        <ng-template kendoGridCellTemplate let-item>
          <input kendoTextBox type="number" min="1" step="1" class="form-control"
                 [(ngModel)]="item.quantidade" [disabled]="!itemDisponivel(item)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Entrada prevista" [width]="135">
        <ng-template kendoGridCellTemplate let-item>
          <strong *ngIf="quantidadeValida(item)">
            {{quantidadeBase(item) | number:'1.0-6'}} {{item.insumo.unidadeMedida.sigla}}
          </strong>
          <span *ngIf="!quantidadeValida(item)">—</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Subtotal" [width]="115">
        <ng-template kendoGridCellTemplate let-item>
          <strong>{{subtotal(item) | currency:'BRL'}}</strong>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>

    <div class="rodape-novo-pedido">
      <div class="observacoes-novo-pedido">
        <label>Observações</label>
        <textarea kendoTextArea class="form-control" maxlength="500" rows="4"
                  [(ngModel)]="observacoes"
                  placeholder="Adicione informações adicionais sobre este pedido..."></textarea>
        <small>{{(observacoes || '').length}}/500 caracteres</small>
      </div>
      <div class="resumo-novo-pedido">
        <div class="resumo-novo-pedido__contagem">
          <span><i class="fas fa-shopping-cart"></i></span>
          <div>
            <small>Itens selecionados</small>
            <strong>{{quantidadeItensSelecionados()}}</strong>
            <em>de {{itens.length}} disponíveis</em>
          </div>
        </div>
        <div class="resumo-novo-pedido__total">
          <small>Total do pedido</small>
          <strong>{{total() | currency:'BRL'}}</strong>
        </div>
        <div class="resumo-novo-pedido__acoes">
          <button type="button" class="btn btn-outline-secondary" (click)="limpeNovoPedido()"
                  [disabled]="enviando || (!quantidadeItensSelecionados() && !observacoes)">
            Cancelar
          </button>
          <button class="btn btn-blue" [disabled]="!podeEnviar()" (click)="envie()">
            <span class="spinner-border spinner-border-sm mr-1" *ngIf="enviando"></span>
            <i class="fas fa-paper-plane mr-1" *ngIf="!enviando"></i>Enviar pedido
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="area === 'realizados'">
    <div class="card card-body bg-light filtros-compras mb-3">
      <div class="row align-items-end">
        <div class="col-md-2 form-group mb-md-0">
          <label>De</label>
          <kendo-datepicker class="w-100" [(ngModel)]="filtro.inicio"></kendo-datepicker>
        </div>
        <div class="col-md-2 form-group mb-md-0">
          <label>Até</label>
          <kendo-datepicker class="w-100" [(ngModel)]="filtro.fim"></kendo-datepicker>
        </div>
        <div class="col-md-2 form-group mb-md-0">
          <label>Status</label>
          <kendo-combobox class="w-100" [data]="status" textField="nome" [(ngModel)]="filtro.status"
                          [allowCustom]="false" [valuePrimitive]="false"></kendo-combobox>
        </div>
        <div class="col-md-2 form-group mb-md-0">
          <label>Código</label>
          <input kendoTextBox class="form-control" [(ngModel)]="filtro.codigo" />
        </div>
        <div class="col-md-3 form-group mb-md-0">
          <label>Produto ou insumo</label>
          <input kendoTextBox class="form-control" [(ngModel)]="filtro.texto" />
        </div>
        <div class="col-md-1 mb-md-0">
          <button class="btn btn-blue" (click)="carregueCompras()" title="Buscar" kendoTooltip>
            <i class="fe-search"></i>
          </button>
        </div>
      </div>
    </div>

    <kendo-grid [data]="compras" [loading]="carregandoCompras" [class]="'gridProdutos'">
      <kendo-grid-messages noRecords="Nenhum pedido encontrado."></kendo-grid-messages>
      <kendo-grid-column title="Pedido" [width]="110">
        <ng-template kendoGridCellTemplate let-compra>
          <strong>#{{compra.pedido.codigo}}</strong>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Fábrica" [width]="190">
        <ng-template kendoGridCellTemplate let-compra>{{compra.fabrica.nome}}</ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Operador" [width]="160">
        <ng-template kendoGridCellTemplate let-compra>
          {{compra.operadorSolicitante?.nome || '—'}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Criado em" [width]="145">
        <ng-template kendoGridCellTemplate let-compra>{{compra.criadoEm | date:'dd/MM/yyyy HH:mm'}}</ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Status" [width]="165">
        <ng-template kendoGridCellTemplate let-compra>
          <span class="badge" [ngClass]="classeStatus(compra.status)">{{statusDescricao(compra.status)}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Total" [width]="110">
        <ng-template kendoGridCellTemplate let-compra><strong>{{compra.pedido.valor | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="" [width]="300" [class]="{'comandos': true}">
        <ng-template kendoGridCellTemplate let-compra>
          <button kendoButton look="flat" (click)="abraDetalhe(compra)" title="Ver detalhes" kendoTooltip
                  [disabled]="processandoId === compra.id">
            <i class="fa fa-eye"></i>
          </button>
          <button kendoButton look="flat" *ngIf="podeCancelar(compra)" (click)="cancele(compra)"
                  title="Cancelar" kendoTooltip [disabled]="!!processandoId">
            <i class="fa fa-ban text-danger"></i>
          </button>
          <button type="button" class="btn btn-sm btn-success ml-1" *ngIf="podeReceber(compra)"
                  (click)="abraDetalhe(compra)" [disabled]="!!processandoId">
            <i class="fa fa-check mr-1"></i>Confirmar recebimento
          </button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </ng-container>
</div>

<kendo-dialog class="modal-produtos-fabrica" *ngIf="exibindoProdutosFabrica"
              (close)="fecheProdutosFabrica()" [minWidth]="320" [width]="1480">
  <kendo-dialog-titlebar (close)="fecheProdutosFabrica()">
    <div class="titulo-produtos-fabrica">
      <i class="fas fa-cube"></i>
      <div>
        <h4>Produtos da fábrica – {{catalogo.fornecimento?.fabrica?.nome}}</h4>
        <small>Selecione um produto da fábrica para utilizá-lo no pedido interno da filial.</small>
      </div>
    </div>
  </kendo-dialog-titlebar>

  <div class="corpo-produtos-fabrica">
    <div class="aviso-produtos-ativos">
      <i class="fas fa-info-circle"></i>
      <div>
        <strong>Exibindo apenas produtos ativos da fábrica.</strong>
        <span>Para entrar em um pedido interno, o produto precisa ser normal, ter preço,
          disponibilidade e exatamente um insumo de estoque ativo.</span>
      </div>
    </div>

    <div class="alert alert-danger mt-3 mb-0" *ngIf="erroProdutosFabrica">
      {{erroProdutosFabrica}}
    </div>

    <div class="filtros-produtos-fabrica">
      <div class="busca-produtos-fabrica">
        <i class="fas fa-search"></i>
        <input type="text" class="form-control" [(ngModel)]="filtroProdutosFabrica.texto"
               (ngModelChange)="alterouFiltroProdutosFabrica()"
               placeholder="Buscar por código, nome do produto ou insumo...">
        <button type="button" *ngIf="filtroProdutosFabrica.texto"
                (click)="filtroProdutosFabrica.texto = ''; alterouFiltroProdutosFabrica()"
                title="Limpar busca" kendoTooltip>
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="campo-filtro-produtos">
        <label>Categoria</label>
        <select class="form-control" [(ngModel)]="filtroProdutosFabrica.categoria"
                (ngModelChange)="alterouFiltroProdutosFabrica()">
          <option value="">Todas</option>
          <option *ngFor="let categoria of categoriasProdutosFabrica" [value]="categoria">
            {{categoria}}
          </option>
        </select>
      </div>
      <div class="campo-filtro-produtos">
        <label>Situação</label>
        <select class="form-control" [(ngModel)]="filtroProdutosFabrica.situacao"
                (ngModelChange)="alterouFiltroProdutosFabrica()">
          <option value="">Todos</option>
          <option value="DISPONIVEL">Disponível</option>
          <option value="NAO_ELEGIVEL">Não elegível</option>
          <option value="ABAIXO_MINIMO">Abaixo do mínimo</option>
        </select>
      </div>
      <div class="campo-filtro-produtos">
        <label>Insumo de estoque</label>
        <select class="form-control" [(ngModel)]="filtroProdutosFabrica.insumo"
                (ngModelChange)="alterouFiltroProdutosFabrica()">
          <option value="">Todos</option>
          <option value="COM">Com insumo</option>
          <option value="SEM">Sem insumo</option>
        </select>
      </div>
      <button type="button" class="btn btn-limpar-produtos" (click)="limpeFiltrosProdutosFabrica()">
        <i class="fas fa-filter mr-2"></i>Limpar filtros
      </button>
      <button type="button" class="btn btn-atualizar-produtos" (click)="abraProdutosFabrica()"
              [disabled]="carregandoProdutosFabrica">
        <i class="fas fa-sync-alt mr-2" [class.fa-spin]="carregandoProdutosFabrica"></i>Atualizar
      </button>
    </div>

    <div class="painel-lista-produtos-fabrica">
      <div class="barra-lista-produtos">
        <div class="total-produtos-encontrados">
          <i class="fas fa-clipboard-list"></i>
          <strong>Produtos encontrados</strong>
          <span>{{produtosFabricaFiltrados().length}}</span>
        </div>
        <div class="legenda-status-produtos">
          <span><i class="disponivel"></i>Disponível</span>
          <span><i class="nao-elegivel"></i>Não elegível</span>
          <span><i class="abaixo-minimo"></i>Abaixo do mínimo</span>
        </div>
        <div class="acoes-lista-produtos">
          <select class="form-control" [(ngModel)]="itensPorPaginaProdutosFabrica"
                  (ngModelChange)="alterouFiltroProdutosFabrica()">
            <option [ngValue]="10">10 por página</option>
            <option [ngValue]="20">20 por página</option>
            <option [ngValue]="50">50 por página</option>
          </select>
          <button type="button" class="btn btn-exportar-produtos" (click)="exporteProdutosFabrica()"
                  [disabled]="!produtosFabricaFiltrados().length">
            <i class="fas fa-download mr-2"></i>Exportar
          </button>
        </div>
      </div>

      <div class="carregando-produtos-fabrica" *ngIf="carregandoProdutosFabrica">
        <span class="spinner-border text-primary"></span>
        <span>Carregando produtos da fábrica...</span>
      </div>

      <div class="table-responsive" *ngIf="!carregandoProdutosFabrica">
        <table class="table tabela-produtos-fabrica mb-0">
          <thead>
            <tr>
              <th class="coluna-selecao-produto"></th>
              <th>Código</th>
              <th>Produto</th>
              <th>Insumo de estoque</th>
              <th>Unidade</th>
              <th>Preço</th>
              <th>Situação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let produto of produtosFabricaDaPagina()"
                [class.produto-selecionado]="ehProdutoFabricaSelecionado(produto)"
                [class.produto-indisponivel]="!produto.disponivelCompraInterna"
                (click)="selecioneProdutoFabrica(produto)">
              <td class="coluna-selecao-produto">
                <input type="radio" name="produtoFabricaPedido"
                       [checked]="ehProdutoFabricaSelecionado(produto)"
                       [disabled]="!produto.disponivelCompraInterna"
                       (change)="selecioneProdutoFabrica(produto)">
              </td>
              <td><strong class="codigo-produto-fabrica">{{produto.codigo || '—'}}</strong></td>
              <td>
                <div class="produto-fabrica-identificacao">
                  <span class="icone-produto-fabrica"><i class="fas fa-cube"></i></span>
                  <div>
                    <strong>{{produto.nome}}</strong>
                    <small>{{produto.descricao || produto.categoria?.nome || 'Sem descrição'}}</small>
                  </div>
                </div>
              </td>
              <td>
                <ng-container *ngIf="produto.insumo; else produtoSemInsumo">
                  <strong>{{produto.insumo.nome}}</strong>
                  <small>{{produto.insumo.codigo || 'Sem código'}} —
                    {{produto.insumo.unidadeBase?.sigla || 'Sem unidade'}}</small>
                </ng-container>
                <ng-template #produtoSemInsumo>—</ng-template>
              </td>
              <td>{{produto.insumo?.unidadeBase?.sigla || 'UN'}}</td>
              <td><strong>{{produto.preco | currency:'BRL'}}</strong></td>
              <td>
                <span class="status-produto-fabrica"
                      [ngClass]="statusProdutoFabrica(produto).classe">
                  {{statusProdutoFabrica(produto).nome}}
                </span>
              </td>
            </tr>
            <tr *ngIf="!produtosFabricaDaPagina().length">
              <td colspan="7" class="sem-produtos-fabrica">
                Nenhum produto encontrado com os filtros informados.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="rodape-lista-produtos" *ngIf="!carregandoProdutosFabrica">
        <span>{{intervaloProdutosFabrica()}}</span>
        <div class="paginacao-produtos-fabrica" *ngIf="totalPaginasProdutosFabrica() > 1">
          <button type="button" (click)="alterePaginaProdutosFabrica(paginaProdutosFabrica - 1)"
                  [disabled]="paginaProdutosFabrica === 1"><i class="fas fa-angle-double-left"></i></button>
          <button type="button" *ngFor="let pagina of paginasProdutosFabrica()"
                  [class.ativa]="pagina === paginaProdutosFabrica"
                  (click)="alterePaginaProdutosFabrica(pagina)">{{pagina}}</button>
          <button type="button" (click)="alterePaginaProdutosFabrica(paginaProdutosFabrica + 1)"
                  [disabled]="paginaProdutosFabrica === totalPaginasProdutosFabrica()">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="rodape-modal-produtos">
    <button type="button" class="btn btn-fechar-produtos" (click)="fecheProdutosFabrica()"
            [disabled]="carregandoProdutosFabrica">Fechar</button>
    <button type="button" class="btn btn-selecionar-produto"
            (click)="confirmeProdutoFabrica()"
            [disabled]="!produtoFabricaSelecionado || carregandoProdutosFabrica">
      <i class="fas fa-check mr-2"></i>Selecionar produto
    </button>
  </div>
</kendo-dialog>

<kendo-dialog *ngIf="compraEmCancelamento" (close)="fecheCancelamento()"
              [minWidth]="320" [width]="520">
  <kendo-dialog-titlebar>Cancelar compra interna</kendo-dialog-titlebar>

  <p>
    Confirme o cancelamento do pedido
    <strong>#{{compraEmCancelamento.pedido.codigo}}</strong>
    da fábrica <strong>{{compraEmCancelamento.fabrica.nome}}</strong>.
  </p>
  <div class="alert alert-warning">
    Esta ação cancela o pedido e libera as reservas de estoque realizadas na fábrica.
  </div>
  <div class="alert alert-danger" *ngIf="erroCancelamento">{{erroCancelamento}}</div>

  <div class="form-group mb-0">
    <label for="motivoCancelamentoCompraInterna">
      Motivo do cancelamento <span class="text-danger">*</span>
    </label>
    <textarea id="motivoCancelamentoCompraInterna" class="form-control" rows="4"
              minlength="5" maxlength="500" required
              [(ngModel)]="motivoCancelamento"
              placeholder="Informe por que esta compra está sendo cancelada"></textarea>
    <small class="text-muted">Informe pelo menos 5 caracteres.</small>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="fecheCancelamento()" [disabled]="!!processandoId">
      Voltar
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmeCancelamento()"
            [disabled]="!motivoCancelamentoValido() || !!processandoId">
      <span class="spinner-border spinner-border-sm mr-1" *ngIf="!!processandoId"></span>
      Confirmar cancelamento
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="detalhe" (close)="fecheDetalhe()" [minWidth]="320" [width]="900">
  <kendo-dialog-titlebar>Compra interna #{{detalhe.pedido.codigo}}</kendo-dialog-titlebar>
  <div class="row mb-3">
    <div class="col-md-6"><strong>Fábrica:</strong> {{detalhe.fabrica.nome}}</div>
    <div class="col-md-3"><strong>Status:</strong> {{statusDescricao(detalhe.status)}}</div>
    <div class="col-md-3"><strong>Total:</strong> {{detalhe.pedido.valor | currency:'BRL'}}</div>
  </div>
  <div class="alert alert-danger" *ngIf="erroRecebimento">{{erroRecebimento}}</div>
  <div class="alert alert-info" *ngIf="pedidoDespachado(detalhe)">
    O pedido está em trânsito. Ao confirmar o recebimento, ele também será marcado como entregue
    na fábrica.
  </div>
  <div class="table-responsive">
    <table class="table table-sm table-striped">
      <thead>
      <tr><th>Insumo</th><th>Unidade fotografada</th><th>Conversão</th><th>Produto da fábrica</th><th>Total</th></tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of detalhe.itens">
        <td>{{item.insumoDestino.nome}}</td>
        <td>{{item.apresentacao.quantidade | number:'1.0-6'}} × {{item.apresentacao.descricao}}</td>
        <td>
          {{item.apresentacao.quantidade | number:'1.0-6'}} ×
          {{item.apresentacao.fatorAplicado | number:'1.0-6'}} =
          <strong>{{item.apresentacao.quantidadeBaseDestino | number:'1.0-6'}}
            {{item.insumoDestino.unidadeBase.sigla}}</strong>
        </td>
        <td>{{item.itemPedido.produto.nome}}</td>
        <td>{{item.custoTotalDestino | currency:'BRL'}}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <p class="mb-0" *ngIf="detalhe.pedido.observacoes"><strong>Observações:</strong> {{detalhe.pedido.observacoes}}</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="fecheDetalhe()">Fechar</button>
    <button kendoButton [primary]="true" *ngIf="podeCancelar(detalhe)" (click)="cancele(detalhe)"
            [disabled]="!!processandoId">Cancelar</button>
    <button kendoButton [primary]="true" *ngIf="podeReceber(detalhe)" (click)="receba(detalhe)"
            [disabled]="!!processandoId">Confirmar recebimento</button>
  </kendo-dialog-actions>
</kendo-dialog>
